import { defineStore } from 'pinia';

export interface AppStateInterface {
  // это нужно чисто для примера работы (U)SSR
  groups: Array<any>;
  serviceList: Array<any>;
  newsList: Array<any>;
  userPublicList: Array<any>;
  issuePublicList: Array<any>;
  issueDepPublicList: Array<any>;
  isMainSsrLoad: boolean;
  authDialogShow: boolean;
  profileDialogShow: boolean;
  profileUnfilledDataDialogShow: boolean;
  showChat: boolean;
}
export const useAppStore = defineStore('app', {
  state: () =>
    <AppStateInterface>{
      groups: [],
      serviceList: [],
      newsList: [],
      userPublicList: [],
      issuePublicList: [],
      issueDepPublicList: [],
      isMainSsrLoad: false,
      authDialogShow: false,
      profileDialogShow: false,
      profileUnfilledDataDialogShow: false,
      showChat: false,
    },

  getters: {},

  actions: {
    setGroups(value: Array<any>) {
      this.groups = value;
    },
    setServiceList(value: Array<any>) {
      this.serviceList = value;
    },
    setNewsList(value: Array<any>) {
      this.newsList = value;
    },
    setUserPublicList(value: Array<any>) {
      this.userPublicList = value;
    },
    setIssuePublicList(value: Array<any>) {
      this.issuePublicList = value;
    },
    setIssueDepPublicList(value: Array<any>) {
      this.issueDepPublicList = value;
    },
    setMainSsrLoad(value: boolean) {
      this.isMainSsrLoad = value;
    },
    setAuthDialog(value: boolean) {
      console.debug('setAuthDialog', value);
      this.authDialogShow = value;
    },
    showAuthDialog() {
      console.debug('showAuthDialog');
      this.authDialogShow = true;
    },
    hideAuthDialog() {
      console.debug('hideAuthDialog');
      this.authDialogShow = false;
    },
    setProfileDialog(value: boolean) {
      this.profileDialogShow = value;
    },
    showProfileDialog() {
      this.profileDialogShow = true;
    },
    hideProfileDialog() {
      this.profileDialogShow = false;
    },
    showProfileUnfilledDataDialog() {
      this.profileUnfilledDataDialogShow = true;
    },
    hideProfileUnfilledDataDialog() {
      this.profileUnfilledDataDialogShow = false;
    },
    openChat(chatId: number, joinChatFunction?: () => Promise<void>) {
      // метод необходим только для того что бы чат на него подписанный стриггреился и открылся
    },
    setShowChat(val: boolean) {
      this.showChat = val;
    },
  },
});
